<template>
      <div no-body> 
      <b-row v-if="lkuLoading" class="justify-content-center mb-2"><span style="color:blue;">Loading data ...</span></b-row>
      <b-row v-else>
        <b-col lg="12">
            <b-input-group>
                <b-input-group-prepend><span class="p-2">Filter</span></b-input-group-prepend>
                  <b-form-input v-model="tblData.bussinesgroup" @keyup.13.native="search()" placeholder="Bussines Group" style="width:23% !important;"></b-form-input>
                  <b-form-input v-model="tblData.vendor_name" @keyup.13.native="search()" placeholder="Vendor Name" class="ml-1" style="width:23% !important;"></b-form-input>
                  <b-form-input v-model="tblData.vendor_code" @keyup.13.native="search()" placeholder="Vendor Code" class="ml-1"></b-form-input>
                <b-input-group-append>
                    <b-button class="btn btn-success ml-1" @click="search()" > <i class="fa fa-refresh"></i> Apply Filter</b-button>
                </b-input-group-append>
                <b-input-group-append>
                  <b-button class="btn btn-secondary ml-1" @click="clearFilter()" > <i class="fa fa-eraser"></i>Clear </b-button>
                </b-input-group-append>
            </b-input-group>
        </b-col>
      </b-row>
        <b-table
          class="mb-0"
          ref="tblVendor"
          responsive
          striped hover small 
          style="font-size:smaller;" 
          :items="data"
          :fields="fields"
          :current-page="tblData.page"
          :per-page="tblData.limit"
          :sort-by.sync="tblData.sortBy"
          :sort-desc.sync="tblData.sortDesc"
          :key="tblData.limit" 
          @row-clicked="selectItem"
        >
          <template v-slot:cell(vendor_address1)="data">
            {{data.item.vendor_address1}} {{data.item.vendor_address2}} {{data.item.vendor_city}}
          </template>
          <template v-slot:cell(vendor_phone)="data">
            <span v-if="(data.item.vendor_phone)">P.{{data.item.vendor_phone}}</span>&nbsp;
            <span v-if="(data.item.vendor_fax)">F.{{data.item.vendor_fax}}</span>
          </template>

        </b-table>
      <b-row>
        <b-col cols="4">
          <div class="pt-2">
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
        </div>        
        </b-col>
        <b-col cols="3">            
            <b-row class="ml-2 mt-2">
              <span class="pt-1 pr-2">Limit per page</span>
              <b-form-select :options="[10, 20, 30, 50, 70, 90, 120]" :plain="true" v-model="tblData.limit"  size="sm" style="width:80px !important;"/>
            </b-row>
        </b-col>
        <b-col cols="5">            
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
      </div>
</template>

<script>
import vendor from "../../apis/vendor";

export default {
  data() {
    return {
      fields: [
          {
            key: "vendor_code",
            label: "Vendor Code",
            sortable: true
          },
          {
            key: "vendor_name",
            label: "Vendor Name",
            sortable: true
          },
          {
            key: "vendor_address1",
            label: "Address"
          },
          {
            key: "vendor_phone",
            label: "Phone/Fax",
          },
          {
            key: "npwp_name",
            label: "Nama WP",
            sortable: true
          },
          { key: "apkodeacc" , 
            label: "GL Account#",
            sortable: true
          },
          
      ],
      tblData: {
        page: 1,
        limit: 10,
        total: 0,
        sortBy: 'vendor_name',
        sortDesc: false,
        vendor_name:'',
        vendor_code:''
      },
      lkuLoading:false
    };
  },
  methods: {
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
    },
    data: async function(ctx) {
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      this.lkuLoading = true;
      let list = await vendor.list(this.tblData);
      this.lkuLoading = false;
      return list;  
    },
    selectItem(item,index) {
      // 'item' will be the row data from items
      // `index` will be the visible row number (available in the v-model 'shownItems')
      this.$emit("click", item);
    },
    refresh() {
      this.$refs.tblVendor.refresh();
    },
    search() {
      this.tblData.page=1
      this.$refs.tblVendor.refresh();
    },
    clearFilter() {
      this.tblData.vendor_code='';
      this.tblData.vendor_name=''
    }   

  }
};
</script>
